export const HEADER_HEIGHT = 50;
export const APP_INSTALLER_HEIGHT = 40;

export const BALANCE_BADGE_TOP_ID = "balance-badge-top";
export const ONBOARDING_DIALOG_CLASS_NAME = "onboarding-dialog";

export const APP_VERSION_FORMAT = "vYYMMDDHHmm";

export const FUNDING_PROFILE_INFO_TOP_BAR_ID = "funding-profile-info-top-bar";

export const TOAST_OFFSET = 24;
export const TOAST_CONTAINER_ID = "react-hot-toast-container";
export const ACTION_TOAST_DURATION_MS = 8000;
